import { render, staticRenderFns } from "./SavedDesignSimple.vue?vue&type=template&id=2baa38ab&scoped=true&"
import script from "./SavedDesignSimple.vue?vue&type=script&lang=js&"
export * from "./SavedDesignSimple.vue?vue&type=script&lang=js&"
import style0 from "./SavedDesignSimple.vue?vue&type=style&index=0&id=2baa38ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa38ab",
  null
  
)

export default component.exports